export enum EUserPermissions {
  createTag = 'CREATE_TAG',
  createBroadcast = 'CREATE_BROADCAST',
  createGroupBroadcast = 'CREATE_GROUP_BROADCAST',
  assignRoles = 'UPDATE_ROLES',
  assignTags = 'ASSIGN_TAG',
  settings = 'SETTINGS',
}
